import { environment } from '@environments/environment';

export function order() {
  return (target: any, propertyKey: string) => {};
}
